const CheckboxActiveSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="1.5" y="1.5" width="13" height="13" rx="3.5" stroke="#333333" />
      <path
        d="M6.73112 9.62959L11.1204 5.24033C11.224 5.13675 11.3448 5.08496 11.4829 5.08496C11.621 5.08496 11.7419 5.13675 11.8454 5.24033C11.949 5.34391 12.0008 5.467 12.0008 5.6096C12.0008 5.7522 11.949 5.87511 11.8454 5.97835L7.09365 10.7431C6.99007 10.8467 6.86923 10.8985 6.73112 10.8985C6.59301 10.8985 6.47216 10.8467 6.36858 10.7431L4.14158 8.51609C4.038 8.41251 3.98828 8.2896 3.99243 8.14734C3.99657 8.00509 4.0506 7.882 4.15453 7.77808C4.25846 7.67415 4.38155 7.62236 4.5238 7.6227C4.66605 7.62305 4.78897 7.67484 4.89255 7.77808L6.73112 9.62959Z"
        fill="#333333"
      />
    </svg>
  );
};

export default CheckboxActiveSvg;
